


define(['angular', 'text!./template.html', 'components/xo-ui-components/src/error-tooltip/directive', 'components/xo-form-components/src/dob-input/directive', 'components/xo-title/dist/directive', 'components/xo-guest-components/src/guest/countryOfResidence/directive', 'components/xo-guest-components/src/guest/emailInput/directive', 'components/xo-guest-components/src/guest/nationality/directive', 'components/xo-guest-components/src/guest/passwordInput/directive', 'components/xo-guest-components/src/guest/onboardOptions/signup/directive', 'components/xo-page-components/src/done/directive', 'components/xo-models/src/onboard/index'], function (angular, template) {
    return angular.module('xo-guest-upgrade-interstitial.directive', ['squid', 'xo-dob-input.directive', 'xo-error-tooltip.directive', 'xo-guest.countryOfResidence', 'xo-guest.emailInput', 'xo-guest.nationality', 'xo-guest.passwordInput', 'xo-guest.signupOptions', 'xo-title.directive', 'xo-done.directive', 'xomodel.onboard', 'xo-tooltip.directive']).directive('xoGuestUpgradeInterstitial', function () {
        return {
            template: template,
            scope: {
                token: '=',
                parentModel: '='
            },
            controller: function controller($rootScope, $scope, $locale, $pxp, $logger, $config, $GuestUpgradeModel, $state, $NationalIdModel, $timeout) {
                $scope.flags = $scope.parentModel.flags;
                if (!$scope.flags) {
                    $logger.info('WPS_interstitial_render_error');
                    $state.go('checkout.genericError', { code: 'PAYMENT_ALREADY_DONE' });
                }
                $scope.flags.wpsInterstitial = true;
                $scope.flags.showMobileEmailSection = true;
                $scope.onboard = $scope.parentModel.onboard;

                $scope.onSubmit = function () {
                    $scope.upgrade = new $GuestUpgradeModel();

                    $scope.upgrade.billing_address = $scope.onboard.billing_address;
                    $scope.upgrade.user = $scope.onboard.user;
                    $scope.upgrade.payerId = $scope.onboard.payerId;
                    $scope.upgrade.transaction = $scope.onboard.transaction;
                    $scope.upgrade.phone = $scope.onboard.phone;
                    $scope.upgrade.nationalIdModel = $NationalIdModel.instance($rootScope.token);
                    $scope.upgrade.experienceChannel = 'HERMES';

                    return $scope.upgrade.save({

                        data: $scope.upgrade.serialize(),

                        success: function success() {
                            $rootScope.mode = 'signup';
                            $logger.info('WPS_guest_upgrade_success');
                            return $state.go('checkout.done');
                        },
                        error: function error() {
                            $logger.info('WPS_guest_upgrade_failed_SERVICE_ERROR');
                            return $state.go('checkout.done', { code: 'NO_UPGRADE' });
                        },
                        contingencies: {
                            DOB_INVALID: function DOB_INVALID() {
                                $logger.info('WPS_guest_upgrade_failed_DOB_INVALID');
                                return $state.go('checkout.done', { code: 'NO_UPGRADE' });
                            },
                            NATID_INVALID: function NATID_INVALID() {
                                $logger.info('WPS_guest_upgrade_failed_NATID_INVALID');
                                return $state.go('checkout.done', { code: 'NO_UPGRADE' });
                            },
                            DEFAULT: function DEFAULT() {
                                $logger.info('WPS_guest_upgrade_failed_Unknown_contingency');
                                return $state.go('checkout.done', { code: 'NO_UPGRADE' });
                            }
                        },
                        validation: function validation() {
                            $logger.info('WPS_guest_upgrade_failed_SERVICE_VALIDATION_ERROR');
                            return $state.go('checkout.done', { code: 'NO_UPGRADE' });
                        }
                    });
                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest-upgrade-interstitial/directive.js
// module id = ./components/xo-guest-components/src/guest-upgrade-interstitial/directive.js
// module chunks = 1